module.exports = __webpack_public_path__ + "img/h1.573d9b40.png";